import { useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import { toast } from "react-toastify";
import { ButtonSkeleton } from "./CalendarComponents/SkeletonLoader.jsx";
import Delete from "../../images/icons/delete.svg";

const DeleteTimeOffModal = ({ isDeleteModalOpen, setIsDeleteModalOpen, setModalIsOpen, timeOffId, token, refetchLeaves }) => {
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);

    const handleConfirmDelete = async () => {
        if (!timeOffId) return;
        try {
            setIsSubmitLoading(true);
            await axios.get(`/api/time-off-request/delete/${timeOffId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success("Time Off Request deleted successfully!", {
                position: "bottom-right",
                autoClose: 2000,
            });
            setModalIsOpen(false);
            handleCancelDelete();
            refetchLeaves();
        } catch (error) {
            console.error("Delete error:", error);
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleCancelDelete = () => {
        setIsDeleteModalOpen(false);
        document.body.classList.remove("ReactModal__Body--open");
    };

    return (
        <Modal
            className="center-modal"
            isOpen={isDeleteModalOpen}
            onRequestClose={handleCancelDelete}
            contentLabel="Confirm Delete"
            style={{
                content: {
                    width: "300px",
                    height: "200px",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    borderRadius: "12px",
                    background: "#fff",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                    border: "none",
                },
                overlay: {
                    backgroundColor: "rgba(0,0,0,0.5)",
                },
            }}
        >
            <div className="delete-modal-content">
                <h2>Confirm Delete</h2>
                <p>Are you sure you want to delete this Time Off Request?</p>
                <div className="delete-modal-buttons">
                    <button
                        className="modal-btn modal-btn-calendar delete"
                        onClick={handleConfirmDelete}
                        disabled={isSubmitLoading}
                    >
                        {isSubmitLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                <ButtonSkeleton width="70px" height="18px" />
                            </div>
                        ) : (
                            <span className="approve-btn-content">
                                Delete
                                <img src={Delete} alt="Delete" />
                            </span>
                        )}
                    </button>
                    <button
                        className="modal-btn modal-btn-calendar cancel"
                        onClick={handleCancelDelete}
                        disabled={isSubmitLoading}
                    >
                        {isSubmitLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                <ButtonSkeleton width="60px" height="18px" />
                            </div>
                        ) : (
                            "Cancel"
                        )}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteTimeOffModal;